import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RedirectGuard} from './redirect.guard';
import {RelatedComponent} from './components/related/related.component';
import {RelatedCategoryComponent} from './components/related-category/related-category.component';
import {RelatedCategoryDetailsComponent} from './components/related-category-details/related-category-details.component';

const routes: Routes = [
  {
    path: '',
    component: RelatedComponent,
    canActivate: [RedirectGuard],
  },
  {
    path: ':categoryType',
    component: RelatedCategoryComponent,
  },
  {
    path: ':categoryType/:categorySlug',
    component: RelatedCategoryDetailsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RelatedRoutingModule {}
